export const student = {
  id: "MENU_STUDENT",
  icon: "LocalLibraryIcon",
  text: "Student",
  child: [
    {
      id: "MENU_STUDENT.MENU_ITEM_1",
      path: "/student/screen-1",
      isPublic: false,
      text: "Submenu 1",
      child: [],
    },
    {
      id: "MENU_STUDENT.MENU_ITEM_2",
      path: "/student/screen-2",
      isPublic: false,
      text: "Submenu 2",
      child: [],
    },
  ],
};
